module.exports = __webpack_public_path__ + "img/plateau.be5030ca.webp";